import React from "react";
import PropTypes from "prop-types";
//import moment from "moment";
//import { extendMoment } from "moment-range";
// Materila UI
import { withStyles } from "material-ui/styles";
import classnames from "classnames";
import Card, {
  CardHeader,
  CardMedia,
  CardContent,
  CardActions
} from "material-ui/Card";
import Collapse from "material-ui/transitions/Collapse";
import Avatar from "material-ui/Avatar";
import IconButton from "material-ui/IconButton";
import Typography from "material-ui/Typography";
import red from "material-ui/colors/red";
import ExpandMoreIcon from "material-ui-icons/ExpandMore";
//import MoreVertIcon from "material-ui-icons/MoreVert";
import Badge from "material-ui/Badge";
import RestaurantMenu from "material-ui-icons/RestaurantMenu";
import LocalBar from "material-ui-icons/LocalBar";
import { DateTime, Interval } from "luxon";
import moment from "moment";

//locals
import { geoDistanceCalculator } from "ddash";
import MenuItem from "./MenuItem";

const styles = theme => ({
  badge: {
    margin: `0 ${theme.spacing.unit * 2}px`
  },

  card: {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",

    width: "100%",
    flexGrow: 1,
    //width: "100%"
    //maxWidth: 350,
    minWidth: 300
  },
  media: {
    height: 150
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  avatar: {
    backgroundColor: red[500]
  },
  flexGrow: {
    flex: "1 1 auto"
  }
});

class VenueItem extends React.Component {
  state = {
    expanded: false,
    selectedMenu: {
      name: "",
      status: "",
      timeRange: "",
      Drinks: 0,
      Food: 0
    },
    timeRange: ""
  };

  componentDidMount = () => {
    const { menus } = this.props.item;
    const currentDateTime = DateTime.local();
    const { month, day, ordinal, weekday } = currentDateTime;

    menus.map(menu => {
      const drinks = menu.items.filter(item => {
        return item.itemType === "Drink";
      });
      const food = menu.items.filter(item => {
        return item.itemType === "Food";
      });

      let startTime = "";

      menu.menuTimes.map(time => {
        let today = true;

        time.monthsOfYear && (today = time.monthsOfYear.includes(month));

        time.daysOfMonth && (today = time.daysOfMonth.includes(day));

        time.daysOfYear && (today = time.daysOfYear.includes(ordinal));

        time.daysOfWeek && (today = time.daysOfWeek.includes(weekday));

        if (!today) {
          return null;
        }

        const timeRange =
          moment(
            DateTime.fromObject({
              hour: time.startTime[0],
              minute: time.startTime[1]
            }).toISO()
          ).format("LT") +
          " - " +
          moment(
            DateTime.fromObject({
              hour: time.endTime[0],
              minute: time.endTime[1]
            }).toISO()
          ).format("LT");

        //checks to see if current selected menu comes before next menu

        if (startTime) {
          if (time.startTime[0] > startTime.hour) {
            return null;
          }
        }

        startTime = DateTime.fromObject({
          hour: time.startTime[0],
          minute: time.startTime[1]
        });

        const endTime = DateTime.fromObject({
          hour: time.endTime[0],
          minute: time.endTime[1]
        });
        const endOfDay = DateTime.fromObject({
          hour: 23,
          minute: 59
        });

        const nowRange = Interval.fromDateTimes(startTime, endTime);
        const now = nowRange.contains(currentDateTime); //=> true
        const soonRange = Interval.fromDateTimes(currentDateTime, endOfDay);
        const soon = soonRange.contains(startTime);

        if (now) {
          this.props.ordertimes(startTime);
          this.setState({
            selectedMenu: {
              name: menu.menuName,
              status: "NOW",
              timeRange,
              Drinks: drinks.length,
              Food: food.length
            }
          });
        } else if (soon) {
          this.props.ordertimes(startTime);
          this.setState({
            selectedMenu: {
              name: menu.menuName,
              status: "SOON",
              timeRange,
              Drinks: drinks.length,
              Food: food.length
            }
          });
        }
        return null;
      });
      return null;
    });
  };

  handleExpandClick = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  render() {
    const {
      venueName,
      menus,
      venueDescription,
      avatarUrl,
      venueGallery,
      address,
      geolocation
    } = this.props.item;

    const { lat, lng } = geolocation;
    const { mylocation } = this.props;

    const { classes } = this.props;

    return (
      <div>
        <Card className={classes.card}>
          <CardHeader
            avatar={
              <Avatar
                src={!avatarUrl ? "" : avatarUrl}
                style={{
                  borderRadius: 2,
                  backgroundColor: "white",
                  border: "1px solid lightgray",
                  color: "black"
                }}
                aria-label={venueName}
                className={classes.avatar}
              >
                {avatarUrl ? "" : venueName.substring(0, 2)}
              </Avatar>
            }
            /*
            action={
              <IconButton>
                <MoreVertIcon />
              </IconButton>
            }
            */
            title={venueName}
            subheader={
              this.state.selectedMenu.status +
              " " +
              this.state.selectedMenu.timeRange
            }
          />

          <CardActions disableActionSpacing>
            {this.state.selectedMenu.Food < 1 ? (
              <div />
            ) : (
              <Badge
                className={classes.badge}
                badgeContent={this.state.selectedMenu.Food}
                color="primary"
              >
                <RestaurantMenu />
              </Badge>
            )}
            {this.state.selectedMenu.Drinks < 1 ? (
              <div />
            ) : (
              <Badge
                className={classes.badge}
                badgeContent={this.state.selectedMenu.Drinks}
                color="primary"
              >
                <LocalBar />
              </Badge>
            )}
            <CardContent>
              <Typography component="p">
                {this.props.mylocation
                  ? geoDistanceCalculator(
                      mylocation.coords.latitude,
                      mylocation.coords.longitude,
                      lat,
                      lng
                    ).toFixed(2) + " miles from me"
                  : address}
              </Typography>
            </CardContent>

            <div className={classes.flexGrow} />
            <IconButton
              className={classnames(classes.expand, {
                [classes.expandOpen]: this.state.expanded
              })}
              onClick={this.handleExpandClick}
              aria-expanded={this.state.expanded}
              aria-label="Show more"
            >
              <ExpandMoreIcon />
            </IconButton>
          </CardActions>
          <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
            <CardContent>
              <CardMedia
                className={classes.media}
                image={venueGallery[0]}
                title="Contemplative Reptile"
              />
              <CardContent>
                <Typography component="p">{venueDescription}</Typography>
              </CardContent>

              {menus.map(item => {
                return (
                  <div key={item.id}>
                    <MenuItem menu={item} />
                  </div>
                );
              })}
            </CardContent>
          </Collapse>
        </Card>
      </div>
    );
  }
}

VenueItem.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(VenueItem);



// WEBPACK FOOTER //
// ./src/Features/City/VenueItem.js